import React from "react";
import { Skeleton } from "../../components/ui/skeleton";

export default function StatCardSkeleton() {
    return (
        <div className="px-5 bg-[hsl(var(--card))] border border--border rounded-[var(--radius)] p-3 text-white">
            <div className="flex items-center justify-between mb-2">
                <Skeleton className="h-4 w-24 rounded" />
                <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <Skeleton className="h-6 w-16 rounded" />
            <Skeleton className="h-3 w-24 mt-2 rounded" />
        </div>
    );
}
